const BYPASS_SPLASH_KEY = 'bypass_splash';

export function setBypassSplashCookie(): void {
  sessionStorage.setItem(BYPASS_SPLASH_KEY, 'true');
}

export function hasBypassSplashCookie(): boolean {
  return sessionStorage.getItem(BYPASS_SPLASH_KEY) === 'true';
}

export function clearBypassSplashCookie(): void {
  sessionStorage.removeItem(BYPASS_SPLASH_KEY);
}
